import FlashLib from 'flashlib_onlyplay';
import { mainGoldFont } from '../fontStyles';
import EntryPoint from 'Engine/EntryPoint';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';
import GameModel from '../model/GameModel';
import { gsap } from 'gsap';

export default class ControllerBonusUi extends FlashLib.MovieClip {
  constructor(...args) {
    super(...args);

    this.init();
    this.addListeners();
  }

  init() {
    this.multiplierPanel = this.getChildByName('multiplierPanel');
    this.multiplier = this.multiplierPanel.getChildByName('multiplier');
    this.multiplierValue = this.multiplier.getChildByName('value');
    this.multiplierValue.style = { ...this.multiplierValue.style, ...mainGoldFont };
    this.hide();
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_RESET_BONUS_FIELD__START, this.updateMultiplier.bind(this));
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
  }

  onGameResized(data) {
    let frame;
    if (data.isLandscape) {
      frame = 1;
    } else if (data.isPortrait) {
      frame = 2;
    }

    if (this.currentFrameIndex !== frame) {
      this.goToFrame(frame);
      const multiplierVisible = this.multiplier.visible;
      const multiplierValue = this.multiplierValue.text;
      this.init();

      if (GameModel.freespinsEnabled) {
        this.show();
        this.multiplier.visible = multiplierVisible;
        this.multiplierValue.text = multiplierValue;
      } else {
        this.hide();
      }
    }

    GlobalDispatcher.dispatch(eEventTypes.EET_SEND_MULTIPLIER_TEXT_FIELD, this.multiplier);
  }

  show() {
    this.setMultiplier(EntryPoint.GameModel.bonusMultiplier);
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.reset();
  }

  reset() {
    this.setMultiplier(1);
  }

  updateMultiplier() {
    this.setMultiplier(EntryPoint.GameModel.bonusMultiplier);
    if (!EntryPoint.GameModel.freespinsEnabled) return;

    const timeline = gsap.timeline();
    timeline.fromTo(this.multiplier,
      { alpha: 0 },
      { alpha: 1, duration: 0.2 })
      .fromTo(this.multiplier.scale,
        { x: 1, y: 1 },
        { x: 1.4, y: 1.4, duration: 0.2, yoyo: true, repeat: 1 }, '<');
  }

  setMultiplier(value) {
    this.multiplier.visible = true;
    this.multiplierValue.text = `×${value}`;
  }
}
